<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1>{{ fileTask.taskName }}</h1>
                    <p>Thanks for providing all of your data, we've now started mapping it into our system. We'll then be able to start migrating your payroll.</p>
                </div>
            </div>
            <br/>
            <button class="btn btn-secondary" @click="router.push({ name: 'Home' })">Return to Home</button>
        </section>

    </div>
  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getFileMappingTask } from '@/services/implementationmanagement.api';


const router  = useRouter()
const loaded = ref(false);
const taskId = router.currentRoute.value.params.taskId;
const error = ref(null);
const fileTask = ref(null);

const errorString = 'An error has occurred. Please contact your Qtac account manager.';


onMounted(async () => {

    try {
        var taskResponse = await getFileMappingTask(taskId);

        if(taskResponse.status !== 200 || taskResponse.data === null || taskResponse.data === undefined) {
            error.value = errorString;
            return null;
        }

        fileTask.value = taskResponse.data;



    } catch (err) {
        error.value = errorString;
        console.error(err);
    }



loaded.value = true;
})


</script>

